import { createSlice } from '@reduxjs/toolkit';
// import type { PayloadAction } from '@reduxjs/toolkit';

export interface PurchaseState {
  value: number
}

const initialState: PurchaseState = {
  value: 0
};

export const purchasesSlice = createSlice({
  name: 'purchases',
  initialState,
  reducers: {
    test: () => {

    }
  }
});

// Action creators are generated for each case reducer function
export const { test } = purchasesSlice.actions;

export default purchasesSlice.reducer;